import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import Card from '../../../../../muiComponents/Card';
import GridChild from '../../../../../muiComponents/GridChild';
import Grid from '../../../../../muiComponents/Grid';
import {
    doubleMD_ColumnGrid,
    gridSpacing20,
    gridSpacing30,
} from '../../../../../utils/commonVariables/grid';
import { formatDate } from '../../../../../utils/formatDates';
import useLanguage from '../../../../../customHooks/useLanguage';
import { useZitoneoSettings } from '../../../contexts/ZitoneoContentContext';

const MembershipSection = () => {
    const translate = useTranslate();
    const language = useLanguage();
    const { ZitoneoMemberDate, ContractType, HotelOwner, IdHotel } =
        useZitoneoSettings();

    return (
        <div className='hotel-content-settings__section'>
            <div className='settings-section__header'>
                <h5 className='settings-section__title'>
                    {translate('membership')}
                </h5>
                <p className='settings-section__description'>
                    {translate('membership_status_description')}
                </p>
            </div>
            <Card className='padding20 flex flex-between'>
                <Grid columnSpacing={gridSpacing30} rowSpacing={gridSpacing20}>
                    <GridChild gridProps={doubleMD_ColumnGrid}>
                        <p className='settings__label'>
                            {translate('member_since')}
                        </p>

                        <p className='settings__membership-section__value'>
                            {formatDate(ZitoneoMemberDate, language)}
                        </p>
                    </GridChild>
                    <GridChild gridProps={doubleMD_ColumnGrid}>
                        <p className='settings__label'>
                            {translate('contract')}
                        </p>

                        <p className='settings__membership-section__value'>
                            {ContractType.Name || '----'}
                        </p>
                    </GridChild>
                    <GridChild gridProps={doubleMD_ColumnGrid}>
                        <p className='settings__label'>zitoneo id</p>

                        <p className='settings__membership-section__value'>
                            {IdHotel}
                        </p>
                    </GridChild>
                    <GridChild gridProps={doubleMD_ColumnGrid}>
                        <p className='settings__label'>{translate('owner')}</p>

                        <p className='settings__membership-section__value'>
                            {HotelOwner}
                        </p>
                    </GridChild>
                </Grid>
            </Card>
        </div>
    );
};

export default MembershipSection;
